import { getRuleDefault, Rule, RuleType } from 'entities/campaign';
import * as React from 'react';
import { connect } from 'react-redux';

import { Selectors as CampaignSelectors } from 'sections/campaigns/state/campaigns';
import { Actions as RulesetActions, Selectors as RulesetSelectors } from 'sections/campaigns/state/rulesets';
import { State } from 'store';
import { Configs } from '../configs';
import { ISelectOption, SelectMini, Box } from '@salecycle/ui-component-library';
import { useTranslation, TFunction } from 'react-i18next';

interface OwnProps {
  rulesetId: string;
}

interface StateProps extends OwnProps {
  options: (t: TFunction<'campaigns'>) => string[];
  newRuleIndex: number;
}

interface DispatchProps {
  addRule: (rulesetId: string, rule: Rule) => void;
}

type Props = StateProps & DispatchProps;

export const AddRule: React.FC<Props> = props => {
  const { t } = useTranslation('campaigns');
  if (!props.options(t).length) {
    return null;
  }

  const getSelectOptions = (): ISelectOption<string>[] => {
    return props.options(t).map((option: RuleType) => ({
      value: option,
      label: Configs.getRuleConfig(t, option).title,
    }));
  };

  const onSelect = (option: ISelectOption<string>): void => {
    const rule = getRuleDefault(option.value as RuleType);
    props.addRule(props.rulesetId, rule);
  };

  return (
    <Box stackItems={true} margin="0 0 10px 0">
      <SelectMini
        ariaLabel={t('campaigns:editor.rulesets.addRule')}
        options={getSelectOptions()}
        onChange={onSelect}
        value={{ value: null, label: t('campaigns:editor.rulesets.addRule') }}
      />
    </Box>
  );
};

const mapState = (state: State, ownProps: OwnProps): StateProps => {
  const ruleset = RulesetSelectors.getUpdatedEntity(state, ownProps.rulesetId);
  const campaign = CampaignSelectors.getEntity(state, ruleset.campaignId);

  return {
    ...ownProps,
    options: t => Configs.getUnusedRuleList(t, campaign.type, ruleset),
    newRuleIndex: ruleset.rules.length,
  };
};

const actionCreators: DispatchProps = {
  addRule: RulesetActions.addRule,
};

export default connect(mapState, actionCreators)(AddRule);
